import IntersectionExample from "./examples/Intersection.Example";
import barsImage from "./examples/bars.png";

export default [
    {
        title: "Basic Intersection",
        component: IntersectionExample,
        code: require("!raw-loader!./examples/Intersection.Example.tsx"),
        dependencies: {
            "bars.png": barsImage
        }
    }
];
